import React, { Component } from 'react';
import MapsLocalShipping from 'material-ui/svg-icons/maps/local-shipping';
import ActionFavoriteBorder from 'material-ui/svg-icons/action/favorite-border';
import ActionAutorenew from 'material-ui/svg-icons/action/autorenew';

import HomeGalleryHeader from './HomeGalleryHeader';
import HomeGalleryFooter from './HomeGalleryFooter';
import * as Typography from './Typography';
import { HowItWorksSection, HowItWorksItem } from './HowItWorks';
import HeroSection from './HeroSection';
import GetInTouchSection from './GetInTouchSection';
import MadeInSFSection from './MadeInSFSection';
import { TestimonialSection, Testimonial, Divider } from './TestimonialSection';

/* global $crisp */

const SectionDivider = (props) => (
  <hr style={{ borderTop: "1px solid #d9d9d9",
               margin: "0 auto",
               width: props.width? props.width : "100%" }} />
)

const iconStyle = {width: "48px", height: "48px", color: "rgb(84, 110, 122)"};

var FAQContent = [
  ["How does Home Gallery Project work?", "Home Gallery Project is a monthly subscription for artwork. Our curators handpick artwork for you and deliver it to your home. After you enjoy your artwork for a month, we swap it out for something fresh. If you love a piece, you can purchase and keep it."],
  ["How large is each artwork?", "Typically our artwork is 24 inches by 18 inches. Before each delivery we confirm the size with you."],
  ["Do I get to pick the artwork?", "Our curators select artwork based on your tastes. Before each delivery we confirm the artwork with you."],
  ["How much does it cost to purchase each artwork?", "The cost varies by artwork, and is generally between $200 and $10,000."],
  ["Who hangs the art?", "We do! We want this to be a hassle-free experience for you."],
  ["What happens if the artwork falls off the wall or gets damaged?", "You should have renters insurance for damage that might occur while the artwork is in your home. If artwork is damaged before it gets to your home or after it leaves your home, it’s our responsibility."],
  ["What is your cancellation policy?", "You can cancel at any time for any reason. We'll arrange a pickup to return the art you currently have at no extra cost. Your final month will be prorated to the day that we pick up the art from you."],
]

class HomePage extends Component {
  render() {
    return (
        <div>
         <HomeGalleryHeader />
         <div>
           <HeroSection
             header="Home Gallery Project delivers fine art from local artists to your doorstep every month. Discover your tastes from the comfort of your couch."
             image="https://firebasestorage.googleapis.com/v0/b/home-gallery-project.appspot.com/o/website%2Fcouch_background.jpg?alt=media&token=7932ebc8-b197-402e-aa52-ea289180e728" />

           <SectionDivider width="33%" />

           <HowItWorksSection text="How it works:">
             <HowItWorksItem icon={<MapsLocalShipping style={iconStyle} />} text="Our curators handpick art for you." />
             <HowItWorksItem icon={<ActionFavoriteBorder style={iconStyle} />} text="Enjoy your art in your home." />
             <HowItWorksItem icon={<ActionAutorenew style={iconStyle} />} text="Get something fresh every month." />
           </HowItWorksSection>

           <SectionDivider />

           <TestimonialSection>
            <Testimonial headline="Every month I can't wait to see my new artwork."
                        quote="I really love that I can try art out and expand what art I'm able to appreciate."
                        attribution="Colin Schimmelfing, Engineering Manager at Clever" />
            <Divider />
           <Testimonial headline="Home feels more like home after art is up."
                        quote="Having just moved to San Francisco amidst starting my own company, this has been an amazing way to find art and make my new space feel like home."
                        attribution="Curt Lederle, Renewable Energy Consultant" />
            <Divider />
            <Testimonial headline="Friends keep asking me where I find my artwork."
                         quote=""
                         attribution="" />
            <Divider />
             <Testimonial headline="I love supporting local artists."
                          quote=""
                          attribution="" />

            </TestimonialSection>

            <SectionDivider />

          <div style={{
              width: "600px",
              maxWidth: "90%",
              margin: 'auto',
              paddingTop: '2em',
              paddingBottom: '2em'
            }}>
            <Typography.Display1>
              Frequently Asked Questions
            </Typography.Display1>
            { FAQContent.map((faq, index) =>
              <div key={faq[0]}>
                <Typography.Subheading>{faq[0]}</Typography.Subheading>
                <Typography.Body2>{faq[1]}</Typography.Body2>
                { <hr /> }
              </div>
            )}
            <div>
              <Typography.Subheading>I have a question that isn't listed here.</Typography.Subheading>
              <Typography.Body2>We'd be happy to answer your question. <a onClick={() => $crisp.push(['do', 'chat:open'])}>Click here to start a chat with us.</a></Typography.Body2>
            </div>
          </div>

            <SectionDivider />

           <GetInTouchSection />
             <SectionDivider />

           <MadeInSFSection />

         </div>
         <HomeGalleryFooter />
        </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/HomePage.js